<template>
  <div class="etms-router-body">
    <el-tabs v-model="outboundactive" @tab-click="handleClick">
      <el-tab-pane label="单包裹出库" name="single">
        <div class="contant-outer-left fl">
          <el-form label-width="100px" class="etms-router-form">
            <el-form-item label="袋号：">
              <el-input size="mini" placeholder="请输入袋号" class="el-width-200" disabled></el-input>
            </el-form-item>
            <el-form-item label="批次号：">
              <el-input size="mini" placeholder="请输入批次号" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="供应商：">
              <el-select size="mini" class="el-width-200" placeholder="请选择出货商" v-model="outboundform.ChannelSupplyId"></el-select>
            </el-form-item>
            <el-form-item label="重量：">
              <el-input type="number" size="mini" placeholder="请输入重量KG(必填)" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="体积：">
              <el-input type="number" size="mini" placeholder="长(cm)" class="el-width-100"></el-input><br />
              <el-input type="number" size="mini" placeholder="宽(cm)" class="el-width-100"></el-input><br />
              <el-input type="number" size="mini" placeholder="高(cm)" class="el-width-100"></el-input>
            </el-form-item>
            <el-form-item label="预警重量：">
              <el-input type="number" size="mini" placeholder="kg" class="el-width-100"></el-input>
            </el-form-item>
            <el-form-item label="单号：">
              <el-input size="mini" placeholder="请扫描单号" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="是否核算：">
              <el-checkbox>核算</el-checkbox>
            </el-form-item>
          </el-form>
        </div>
        <div class="contant-outer-right fl">
          <el-table :data="outboundlist" class="etms-router-list">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="客户" prop="CustomerName"></el-table-column>
            <el-table-column label="供应商" prop="ChannelSupplyName"></el-table-column>
            <el-table-column label="渠道" prop="ChannelName"></el-table-column>
            <el-table-column label="线路">
              <template slot-scope="scope">
                {{scope.row.LineName}}-{{scope.row.ShipmentRegionName}}-{{scope.row.PurposeRegionName}}
              </template>
            </el-table-column>
            <el-table-column label="单号" prop="Odd"></el-table-column>
            <el-table-column label="批次号" prop="OutboundBatch"></el-table-column>
            <el-table-column label="袋号" prop="BagCode"></el-table-column>
            <el-table-column label="入库重" prop="PutStorageTotalWeight"></el-table-column>
            <el-table-column label="入库体积">
              <template slot-scope="scope">
                {{scope.row.ParcelPutStorageLong}}*{{scope.row.ParcelPutStorageWide}}*{{scope.row.ParcelPutStorageHigh}}
              </template>
            </el-table-column>
            <el-table-column label="出库重" prop="OutboundTotalWeight"></el-table-column>
            <el-table-column label="出库体积">
              <template slot-scope="scope">
                {{scope.row.OutboundLong}}*{{scope.row.OutboundWide}}*{{scope.row.OutboundHigh}}
              </template>
            </el-table-column>
            <el-table-column label="总费用" prop="TotalFee"></el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <table border="0" class="waybill-fee-table" cellpadding="0" cellspacing="0">
                  <tr>
                    <th>费用类型</th>
                    <th>标准价</th>
                    <th>折扣价</th>
                    <th>计费值</th>
                    <th>计费公示</th>
                    <th>备注</th>
                  </tr>
                  <tr v-for="item in scope.row.WaybillFees" :key="item.WaybillFeeId">
                    <td>{{item.WaybillFeeType}}</td>
                    <td>{{item.StandardFee}}</td>
                    <td>{{item.DiscountFee}}</td>
                    <td>{{item.BillingValue}}</td>
                    <td>{{item.BillingFormulaString}}</td>
                    <td>{{item.BillingFormulaNote}}</td>
                  </tr>
                </table>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="多包裹出库" name="multiple">
        <div style="padding-bottom:5px;">
          <el-input size="mini" placeholder="请输入批次号" class="el-width-200" v-model="multipleform.batch"></el-input>
          <el-select size="mini" class="el-width-200" placeholder="请选择出货商" v-model="multipleform.ChannelSupplyId"></el-select>
          <el-input size="mini" placeholder="请扫描单号" class="el-width-200" v-model="multipleform.odd" @keyup.enter.native="submitMultiple"></el-input>
        </div>
        <div style="padding:5px 0;" v-show="multipleform.isshow">
          <span>单号：</span><span>{{multipleform.odd}}</span>
          <span>出库批次：</span><span>{{multipleform.batch}}</span>
          <span>客户：</span><span>{{multipleform.CustomerName}}</span>
          <span>渠道：</span><span>{{multipleform.ChannelName}}</span>
          <span>线路：</span><span>{{multipleform.LineName}}-{{multipleform.ShipmentRegionName}}-{{multipleform.PurposeRegionName}}</span>
          <span>数量：</span><span>{{multipleform.PutStorageQuantity}}</span>
        </div>

        <el-table :data="multipleform.parcellist" :border="true" v-show="multipleform.isshow" class="etms-router-list">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column label="箱号" prop="CaseNumber"></el-table-column>
          <el-table-column label="子单号" prop="ParcleOdd"></el-table-column>
          <el-table-column label="入库重量" prop="PutStorageTotalWeight" width="70px" align="center"> </el-table-column>
          <el-table-column label="入库长" prop="ParcelPutStorageLong" width="70px" align="center"> </el-table-column>
          <el-table-column label="入库宽" prop="ParcelPutStorageWide" width="70px" align="center"> </el-table-column>
          <el-table-column label="入库高" prop="ParcelPutStorageHigh" width="70px" align="center"> </el-table-column>
          <el-table-column label="入库体积重" prop="ParcelPutStorageVolumeWeight" width="90px" align="center"> </el-table-column>
          <el-table-column label="出库重量" align="center">
            <template slot-scope="scope">
              <el-input type="number" size="mini" class="el-width-100" v-model="scope.row.ParcelOutboundWeight"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="出库长" align="center">
            <template slot-scope="scope">
              <el-input type="number" size="mini" class="el-width-100" v-model="scope.row.ParcelOutboundLong"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="出库宽" align="center">
            <template slot-scope="scope">
              <el-input type="number" size="mini" class="el-width-100" v-model="scope.row.ParcelOutboundWide"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="出库高" align="center">
            <template slot-scope="scope">
              <el-input type="number" size="mini" class="el-width-100" v-model="scope.row.ParcelOutboundHigh"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="出库体积重" align="center" prop="ParcelOutboundVolumeWeight"></el-table-column>
          <el-table-column align="center" width="70px">
            <template slot="header" slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="添加更多包裹" placement="top">
                <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="insertMultiple()"></el-button>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="删除此包裹" placement="top">
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteMultiple(spoce.$index,spoce.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding:10px;" v-show="multipleform.isshow">
          <el-button size="mini" type="primary" class="fr" @click="submitMultipleOutbound">确认出库</el-button>
        </div>
        <div class="clear"></div>
        <div style="padding-top: 10px;">
          <el-table :data="multiplelist" :border="true" class="etms-router-list">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column label="单号" prop="Odd"></el-table-column>
            <el-table-column label="客户" prop="CustomerName"></el-table-column>
            <el-table-column label="渠道" prop="ChannelName"></el-table-column>
            <el-table-column label="线路">
              <template slot-scope="scope">
                {{scope.row.LineName}}-{{scope.row.ShipmentRegionName}}-{{scope.row.PurposeRegionName}}
              </template>
            </el-table-column>
            <el-table-column label="批次" prop="OutboundBatch"></el-table-column>
            <el-table-column label="入库重量" prop="PutStorageTotalWeight"></el-table-column>
            <el-table-column label="入库体积" prop="PutStorageTotalVolume"></el-table-column>
            <el-table-column label="入库体积重" prop="PutStorageTotalVolumeWeight"></el-table-column>
            <el-table-column label="出库重量" prop="OutboundTotalWeight"></el-table-column>
            <el-table-column label="出库体积" prop="OutboundTotalVolume"></el-table-column>
            <el-table-column label="出库体积重" prop="OutboundTotalVolumeWeight"></el-table-column>
            <el-table-column label="总费用" prop="TotalFee"></el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <table border="0" class="waybill-fee-table" cellpadding="0" cellspacing="0">
                  <tr>
                    <th>费用类型</th>
                    <th>标准价</th>
                    <th>折扣价</th>
                    <th>计费值</th>
                    <th>计费公示</th>
                    <th>备注</th>
                  </tr>
                  <tr v-for="item in scope.row.WaybillFees" :key="item.WaybillFeeId">
                    <td>{{item.WaybillFeeType}}</td>
                    <td>{{item.StandardFee}}</td>
                    <td>{{item.DiscountFee}}</td>
                    <td>{{item.BillingValue}}</td>
                    <td>{{item.BillingFormulaString}}</td>
                    <td>{{item.BillingFormulaNote}}</td>
                  </tr>
                </table>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="集装箱出库" name="container">
        <div class="contant-outer-left fl">
          <el-form label-width="100px" class="etms-router-form">
            <el-form-item label="供应商：">
              <el-select size="mini" class="el-width-200" placeholder="请选择出货商" v-model="containerform.ChannelSupplyId"></el-select>
            </el-form-item>
            <el-form-item label="批次：">
              <el-input size="mini" placeholder="请输入批次号" class="el-width-150" v-model="containerform.batch"></el-input>
            </el-form-item>
            <el-form-item label="重量：">
              <el-input size="mini" type="number" placeholder="请录入重量" class="el-width-150" v-model="containerform.weight"></el-input>
            </el-form-item>
            <el-form-item label="数量：">
              <el-input-number size="mini" class="el-width-100" v-model="containerform.quantity"></el-input-number>
            </el-form-item>
            <el-form-item label="单号：">
              <el-input size="mini" placeholder="请扫描单号" class="el-width-150" v-model="containerform.odd" @keyup.enter.native="submitContainer"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="contant-outer-right fl">
          <el-table :data="containerlist" class="etms-router-list">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="客户" prop="CustomerName"></el-table-column>
            <el-table-column label="渠道" prop="ChannelName"></el-table-column>
            <el-table-column label="线路">
              <template slot-scope="scope">
                {{scope.row.LineName}}-{{scope.row.ShipmentRegionName}}-{{scope.row.PurposeRegionName}}
              </template>
            </el-table-column>
            <el-table-column label="单号" prop="Odd"></el-table-column>
            <el-table-column label="批次号" prop="OutboundBatch"></el-table-column>
            <el-table-column label="入库重" prop="PutStorageTotalWeight"></el-table-column>
            <el-table-column label="入库数量" prop="PutStorageQuantity"></el-table-column>
            <el-table-column label="出库重" prop="OutboundTotalWeight"></el-table-column>
            <el-table-column label="出库数量" prop="OutboundQuantity"></el-table-column>
            <el-table-column label="总费用" prop="TotalFee"></el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <table border="0" class="waybill-fee-table" cellpadding="0" cellspacing="0">
                  <tr>
                    <th>费用类型</th>
                    <th>标准价</th>
                    <th>折扣价</th>
                    <th>计费值</th>
                    <th>计费公示</th>
                    <th>备注</th>
                  </tr>
                  <tr v-for="item in scope.row.WaybillFees" :key="item.WaybillFeeId">
                    <td>{{item.WaybillFeeType}}</td>
                    <td>{{item.StandardFee}}</td>
                    <td>{{item.DiscountFee}}</td>
                    <td>{{item.BillingValue}}</td>
                    <td>{{item.BillingFormulaString}}</td>
                    <td>{{item.BillingFormulaNote}}</td>
                  </tr>
                </table>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="添加包裹信息" :visible.sync="multiplevisible" :modal-append-to-body="false" center width="400px">
      <el-form label-width="100px">
        <el-form-item label="箱号：">
          <el-input size="mini" placeholder="请输入包裹箱号" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="子单号：">
          <el-input size="mini" placeholder="请输入子单号" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="出库重量：">
          <el-input size="mini" type="number" placeholder="请录入重量" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="出库体积：">
          <el-input size="mini" type="number" placeholder="长" class="el-width-70"></el-input>
          <el-input size="mini" type="number" placeholder="宽" class="el-width-70"></el-input>
          <el-input size="mini" type="number" placeholder="高" class="el-width-70"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="dialogMultipleSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      outboundactive: 'single',
      outboundform: {
        ChannelSupplyId: ''
      },
      outboundlist: [
        {
          WaybillId: '',
          OptimisticLock: '',
          OldOptimisticLock: '',
          CustomerId: '',
          ChannelSupplyName: 'DHL广州公司',
          CustomerName: '广州凯捷物流',
          ChannelName: '广州小包',
          LineName: '1区',
          ShipmentRegionName: '中国',
          PurposeRegionName: '美国',
          Odd: '12345678',
          OutboundBatch: '20181204ETS001',
          BagCode: '01',
          PutStorageTotalWeight: '1.50',
          ParcelPutStorageLong: '10',
          ParcelPutStorageWide: '20',
          ParcelPutStorageHigh: '7',
          OutboundTotalWeight: '1.52',
          OutboundLong: '11',
          OutboundWide: '22',
          OutboundHigh: '6',
          TotalFee: '52',
          WaybillFees: [
            {
              WaybillFeeId: '0',
              WaybillFeeType: '运费',
              StandardFee: '45',
              DiscountFee: '42',
              BillingValue: '1.52',
              BillingFormulaString: '(28.1954*1.52)*0.98',
              BillingFormulaNote: '不足1KG按1KG算'
            },
            {
              WaybillFeeId: '1',
              WaybillFeeType: '挂号费',
              StandardFee: '10',
              DiscountFee: '10',
              BillingValue: '1.52',
              BillingFormulaString: '10',
              BillingFormulaNote: ''
            }
          ]
        }
      ],
      multipleform: {
        isshow: false,
        batch: '20181204ETS001',
        odd: 'RD2156984521CN',
        waybillid: '',
        ChannelSupplyId: '',
        CustomerName: '广州腾汇',
        ChannelName: '香港DHL',
        LineName: '1区',
        ShipmentRegionName: '中国',
        PurposeRegionName: '俄罗斯',
        parcellist: [
          {
            CaseNumber: '1',
            ParcelCode: '001',
            ParcelBarcode: '',
            ParcleOdd: 'RD2156984521CN-1',
            ParcelPutStorageLong: 0,
            ParcelPutStorageWide: 0,
            ParcelPutStorageHigh: 0,
            ParcelPutStorageWeight: 0,
            ParcelPutStorageVolumeWeight: 0,
            ParcelOutboundLong: '',
            ParcelOutboundWide: '',
            ParcelOutboundHigh: '',
            ParcelOutboundWeight: '11',
            ParcelOutboundVolumeWeight: ''
          }
        ]
      },
      multiplevisible: false,
      multiplelist: [
        {
          WaybillId: '',
          OptimisticLock: '',
          OldOptimisticLock: '',
          CustomerId: '',
          CustomerName: '广州凯捷物流',
          ChannelName: '广州小包',
          LineName: '1区',
          ShipmentRegionName: '中国',
          PurposeRegionName: '美国',
          Odd: '12345678',
          OutboundBatch: '20181204ETS001',
          BagCode: '01',
          PutStorageTotalWeight: '1.50',
          PutStorageTotalVolume: '7',
          OutboundTotalWeight: '1.52',
          OutboundTotalVolume: '6',
          TotalFee: '52',
          WaybillFees: [
            {
              WaybillFeeId: '0',
              WaybillFeeType: '运费',
              StandardFee: '45',
              DiscountFee: '42',
              BillingValue: '1.52',
              BillingFormulaString: '(28.1954*1.52)*0.98',
              BillingFormulaNote: '不足1KG按1KG算'
            },
            {
              WaybillFeeId: '1',
              WaybillFeeType: '挂号费',
              StandardFee: '10',
              DiscountFee: '10',
              BillingValue: '1.52',
              BillingFormulaString: '10',
              BillingFormulaNote: ''
            }
          ]
        }
      ],
      containerform: {
        ChannelSupplyId: '',
        batch: '',
        weight: '',
        quantity: '',
        odd: ''
      },
      containerlist: [
        {
          WaybillId: '',
          OptimisticLock: '',
          OldOptimisticLock: '',
          CustomerId: '',
          CustomerName: '广州凯捷物流',
          ChannelName: '广州小包',
          LineName: '1区',
          ShipmentRegionName: '中国',
          PurposeRegionName: '美国',
          Odd: '12345678',
          OutboundBatch: '20181204ETS001',
          PutStorageTotalWeight: '1.50',
          PutStorageQuantity: 1,
          OutboundTotalWeight: '1.52',
          OutboundQuantity: 1,
          TotalFee: '52',
          WaybillFees: [
            {
              WaybillFeeId: '0',
              WaybillFeeType: '运费',
              StandardFee: '45',
              DiscountFee: '42',
              BillingValue: '1.52',
              BillingFormulaString: '(28.1954*1.52)*0.98',
              BillingFormulaNote: '不足1KG按1KG算'
            },
            {
              WaybillFeeId: '1',
              WaybillFeeType: '挂号费',
              StandardFee: '10',
              DiscountFee: '10',
              BillingValue: '1.52',
              BillingFormulaString: '10',
              BillingFormulaNote: ''
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleClick () {

    },
    submitMultiple () {
      this.multipleform.isshow = true
    },
    deleteMultiple (index, row) { },
    insertMultiple () {
      this.multiplevisible = true
    },
    submitMultipleOutbound () {
      this.multipleform.isshow = false
    },
    dialogMultipleSave () { },
    submitContainer () { }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";

.waybill-fee-table {
  border: 0px;
  width: 100%;
  margin: 0;
  padding: 0;
}

.waybill-fee-table th,
.waybill-fee-table td {
  padding-left: 20px;
  line-height: 20px;
}

.el-table__expanded-cell[class*="cell"] {
  padding: 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/outbound_processing.vue